import { SelectOption } from '../types'

export const externalConstructionType = [
  'Weatherboard',
  'Brick Veneer',
  'Full Brick',
  'Concrete Structure',
]

export const getExternalConstructionTypeOptions = (propertyType: string): SelectOption[] =>
  externalConstructionTypeMap[propertyType]?.map((externalConstructionType) => ({
    value: externalConstructionType,
    label: externalConstructionType,
  })) ?? []

export const externalConstructionTypeOptions: SelectOption[] = externalConstructionType.map(
  (externalConstructionType) => ({
    value: externalConstructionType,
    label: externalConstructionType,
  }),
)

export const externalConstructionTypeMap: Record<string, string[]> = {
  'Standard House': ['Weatherboard', 'Brick Veneer', 'Full Brick'],
  'Standard House_Two': ['Brick Veneer', 'Full Brick'],
  'Architecturally Designed Home': ['Full Brick'],
  Townhouse: ['Full Brick'],
  Units: ['Concrete structure'],
  Apartments: ['Concrete structure'],
  'Project Home': ['Brick Veneer'],
  'Project Units': ['Brick Veneer'],
}
